import EndSprintConfirmation from './EndSprintConfirmation';

export default EndSprintConfirmation;
